import fonts from 'styles/fonts';
import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
};

const SubText = styled('p')<Props>({
  fontSize: fonts.size['10'],
  opacity: 0.7,
});

export default SubText;
